import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router"

import { healthSetProp } from "../../redux/health.slice"

export const useVampHistoricalDataMode = () => {
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const { isHistoricalDataMode, enrollmentData } = useSelector((state) => state.health)

  const isHistoricalDataModeBannerActive =
    isHistoricalDataMode && pathname.includes("/health/monitoring")

  const switchToHistoricalDataMode = () => {
    if (enrollmentData?.historical_data_available) {
      dispatch(healthSetProp({ key: "isHistoricalDataMode", value: true }))
    }
  }

  return {
    isHistoricalDataMode,
    isHistoricalDataModeBannerActive,
    isHistoricalDataAvailable: enrollmentData?.historical_data_available,
    switchToHistoricalDataMode
  }
}
